import {
  Building07,
  Settings03,
  CreditCard01,
  CreditCardCheck,
  File05,
  Users01
} from "untitledui-js-base";
import { Door } from "./components/Door";

export enum Links {
  CREDIT_IMPACT = "Credit impact",
  RENTERS = "Renters",
  RENT_REPORTING = "Rent reporting",
  APPLICATIONS = "Applications",
  SCREENING_SETTINGS = "Screening settings",
  PROPERTIES = "Properties",
  UNITS = "Units"
}

export const boomReportLinks = [
  {
    name: Links.RENT_REPORTING,
    to: "/rent-reporting",
    Icon: CreditCardCheck
  },
  {
    name: Links.CREDIT_IMPACT,
    to: "/credit-impact",
    Icon: CreditCard01
  }
];

export const globalLinks = [
  {
    name: Links.RENTERS,
    to: "/renters",
    Icon: Users01
  },
  { name: Links.PROPERTIES, to: "/properties", Icon: Building07 },
  { name: Links.UNITS, to: "/units", Icon: Door }
];

export const boomScreenLinks = [
  { name: Links.APPLICATIONS, to: "/applications", Icon: File05 },
  {
    name: Links.SCREENING_SETTINGS,
    to: "/verification-templates",
    Icon: Settings03
  }
];
